export default "__VITE_ASSET__394faf55__"